import { render, staticRenderFns } from "./coupons.html?vue&type=template&id=631a1bd7&scoped=true&external"
import script from "./coupons.js?vue&type=script&lang=js&external"
export * from "./coupons.js?vue&type=script&lang=js&external"
import style0 from "./coupons.scss?vue&type=style&index=0&id=631a1bd7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a1bd7",
  null
  
)

export default component.exports